import React from 'react'
import { Pagination } from 'react-bootstrap'

// State-driven pager for report screens that keep their filters in state
const ReportPager = ({ page, pages, onChange }) =>
  pages > 1 ?
    <Pagination size='sm'>
      {[...Array(pages).keys()].map((x) => (
        <Pagination.Item
          key={x + 1}
          active={x + 1 === page}
          onClick={() => onChange(x + 1)}
        >
          {x + 1}
        </Pagination.Item>
      ))}
    </Pagination>
  : null

export default ReportPager
